<template>
  <v-layout
    v-if="informationMessage!=null && !isHide()"
    :style="`height: 40px;background-color: ${backgroundColor}`"
    align-center
    class="ma-0 pa-0"
    d-flex
    justify-start
  >
    <v-img
      class="ml-4 mr-4"
      height="13px"
      max-height="13px"
      max-width="101px"
      src="../assets/information.png"
      width="101px"
    />
    <div
      :style="`width:2px; height:50%;background-color:${accentColor}`"
      class="mr-4"
    />
    <v-clamp
      :max-lines="1"
      autoresize
      class="pa-0 ma-0"
      style="font-size: 13px;color: #797979;width: 100%;"
    >
      {{ informationDate }}
      {{
        informationMessage
      }}
    </v-clamp>
    <v-btn
      class="ma-0 mr-2 ml-2"
      color="secondary"
      elevation="0"
      small
      tile
      @click="moreDialog=true"
    >
      もっと見る
    </v-btn>
    <v-dialog
      v-model="moreDialog"
      max-width="800"
    >
      <v-card>
        <v-card-title class="mb-2">
          <v-img
            height="13px"
            max-height="13px"
            max-width="101px"
            src="../assets/information.png"
            width="101px"
          />
        </v-card-title>
        <v-card-text
          v-for="(item) in informationList "
          :key="item.id"
          two-line
        >
          <h2 class="informationTitle">
            {{ item.title }}
          </h2>
          <div style="font-weight: bold;">
            {{ item.date }}
          </div>
          <div
            style="white-space:pre-wrap;"
            class="informationMessage"
            v-html="item.message"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="moreDialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {mapState} from "vuex";
import VClamp from 'vue-clamp'

export default {
  name: "Information",
  components: {
    VClamp
  },
  methods: {
    isHide() {
      return this.$route.path.startsWith("/novels/") && this.hideAppbar
    }
  },

  computed: {
    ...mapState({
      informationList: state => state.informationModule.informationList,
      hideAppbar: state => state.userModule.hideTopBottomMode
    }),
  },
  data() {
    return {
      informationMessage: null,
      informationDate: null,
      accentColor: null,
      backgroundColor: null,
      moreDialog: false
    }
  },
  watch: {
    informationList: {
      handler: function () {
        if (this.informationList != null && this.informationList.length > 0) {
          const information = this.informationList[0]
          this.informationMessage = information.title
          this.informationDate = information.date
        }
      }, immediate: true
    },
    '$vuetify.theme.themes.light.secondary'(old, newValue) {
      this.accentColor = this.$vuetify.theme.themes.light.secondary
      const primary = this.$vuetify.theme.themes.light.primary
      const red = parseInt(primary.substring(1, 3), 16);
      const green = parseInt(primary.substring(3, 5), 16);
      const blue = parseInt(primary.substring(5, 7), 16);
      this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary


    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'

    if (!this.$store.state.informationModule.informationList) {
      this.$store.dispatch("informationModule/getValue")
    }
  }
}
</script>

<style>
.informationTitle {
  margin-top: 8px;
  margin-left: 4px;
  margin-bottom: 4px;
  border-left: 6px solid #2f2116;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  padding: 5px 0 5px 15px;
}

.informationMessage a {
  font-size: 15px;
  color: var(--v-secondary-base) !important;
  text-decoration: none;
  font-weight: bold !important;
}

.informationMessage a:hover {
  text-decoration: underline;
}
</style>